var map = {
	"./Ginetex-Symbols.woff": 23661,
	"./Gotham-Bold.woff": 5748,
	"./Gotham-BoldItalic.woff": 57305,
	"./Gotham-Italic.woff": 7552,
	"./Gotham.woff": 44607,
	"./wash_care_symbol.woff": 96315,
	"./wash_care_symbols.woff": 38581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43776;